import { csvEscape, filterLabelFromList, safeCsvSlug, triggerCsvDownload } from './perfHubCsvUtils';

const TREND_LABELS = {
  improving: 'Improving',
  declining: 'Declining',
  flat: 'Flat',
};

function formatBadges(badges) {
  return (badges || []).join('; ');
}

export function buildCreatorIntelligenceCsvRows(creators) {
  const headers = [
    'instagram_handle',
    'invite_status',
    'connected',
    'has_metrics',
    'delivery_score',
    'performance_score',
    'efficiency_score',
    'rebook_score',
    'ugc_score',
    'ugc_suggested',
    'phase2_recommended',
    'quality_band',
    'trend',
    'badges',
    'engagement',
    'reach',
    'saved',
    'plays',
    'save_rate',
    'media_type',
    'permalink',
    'recommended_intent',
    'row_id',
  ];

  const lines = [headers.map(csvEscape).join(',')];

  for (const c of creators) {
    const m = c.metrics || {};
    lines.push(
      [
        c.instagram_handle,
        c.invite_status,
        c.connected ? 'yes' : 'no',
        c.has_metrics ? 'yes' : 'no',
        c.delivery_score,
        c.performance_score,
        c.efficiency_score,
        c.rebook_score,
        c.ugc_score,
        c.ugc_suggested ? 'yes' : 'no',
        c.phase2_recommended ? 'yes' : 'no',
        c.quality_band,
        TREND_LABELS[c.trend] || c.trend || '',
        formatBadges(c.badges),
        m.engagement,
        m.reach,
        m.saved,
        m.plays,
        m.save_rate,
        m.media_type,
        c.permalink,
        c.recommended_intent,
        c.row_id,
      ]
        .map(csvEscape)
        .join(','),
    );
  }

  return lines.join('\n');
}

export function downloadCreatorIntelligenceCsv(creators, { campaignName, filterId, filters }) {
  if (!creators?.length) return;

  const filterLabel = filterLabelFromList(filters, filterId, 'All creators');
  const safeCampaign = safeCsvSlug(campaignName);
  const safeFilter = filterLabel.replace(/[^\w.-]+/g, '_').toLowerCase();
  const csv = buildCreatorIntelligenceCsvRows(creators);
  triggerCsvDownload(`creator-intelligence-${safeCampaign}-${safeFilter}.csv`, csv);
}
